module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Db-Ga-Ha-Ia.33512477.png";